import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

// import '@style/components/fullScreenButton.scss';
import '../styles/components/fullScreenButton.scss';

const FullScreenWrapperClassName = 'full-screen-by-fs-button';

export const ExitFullPageBtn = ({
  rootNode,
  exitFullScreen,
  shouldShow = false,
}) => {
  const [hasRootNode, setHasRootNode] = useState(false);

  useEffect(() => {
    if (!rootNode) {
      return;
    }
    setHasRootNode(true);
  }, [rootNode]);

  return (
    hasRootNode &&
    shouldShow &&
    ReactDOM.createPortal(
      <div
        className="exit-fullscreen-button full-screen-button"
        onClick={exitFullScreen}
      >
        <span className="appkiticon icon-minimize-fill a-btn-icon" />
      </div>,
      rootNode,
    )
  );
};

export const useFullScreen = (elemId, scrollIntoViewAfterExit) => {
  const [shownFullScreen, setShowFullScreen] = useState(false);
  const [toFullScreenElem, setToFullScreenElem] = useState(null);
  const [initialized, setInitilized] = useState(null);

  const fullScreenHandler = () => {
    if (!document.fullscreenElement) {
      setShowFullScreen(false);
    }
  };

  const addFullScreenEventListener = (elem) => {
    elem.addEventListener('fullscreenchange', fullScreenHandler);
  };

  const removeFullScreenEventListener = (elem) => {
    elem.removeEventListener('fullscreenchange', fullScreenHandler);
  };

  // remove style wrapper from className after exit full-screen mode
  useEffect(() => {
    if (shownFullScreen === false && toFullScreenElem) {
      toFullScreenElem.classList.remove(FullScreenWrapperClassName);
    }
  }, [shownFullScreen, toFullScreenElem]);

  useEffect(() => {
    const elemToFullScreen = document.querySelector(elemId);

    if (!elemToFullScreen) {
      return () => {};
    }

    setToFullScreenElem(elemToFullScreen);
    addFullScreenEventListener(elemToFullScreen);
    return () => removeFullScreenEventListener(elemToFullScreen);
  }, [initialized]);

  const iframeRequestEnterFullScreen = () => {
    if (toFullScreenElem?.requestFullscreen) {
      toFullScreenElem.requestFullscreen();
      toFullScreenElem.classList.add(FullScreenWrapperClassName);
    }
  };

  const iframeRequestExitFullScreen = () => {
    document.exitFullscreen();
    if (!toFullScreenElem) {
      return;
    } else if (scrollIntoViewAfterExit) {
      setTimeout(() => {
        toFullScreenElem.scrollIntoViewIfNeeded();
      }, 100);
    }
    setShowFullScreen(false);
  };

  const toggleFullScreen = () => {
    if (!shownFullScreen) {
      iframeRequestEnterFullScreen();
    } else {
      iframeRequestExitFullScreen();
    }
    setShowFullScreen((b) => !b);
  };

  return {
    shownFullScreen,
    toggleFullScreen,
    setInitilized,
    toFullScreenElem,
  };
};

const FullScreenButton = ({
  elemId,
  onToggleFullScreen = () => {},
  scrollIntoViewAfterExit,
}) => {
  const { shownFullScreen, toggleFullScreen, toFullScreenElem } = useFullScreen(
    elemId,
    scrollIntoViewAfterExit,
  );

  const onToggle = () => {
    toggleFullScreen();
    onToggleFullScreen();
  };

  return (
    <>
      <div className="full-screen-button" onClick={onToggle}>
        <span className="icon-expand-fill a-btn-icon appkiticon" />
      </div>
      <ExitFullPageBtn
        exitFullScreen={onToggle}
        rootNode={toFullScreenElem}
        shouldShow={shownFullScreen}
      />
    </>
  );
};

export default FullScreenButton;
